import type { FC } from "react";
import type { ComponentOptions } from "../../DragDropTypes";
import { useSpacerHeight } from "./SpacerComponent";

interface Props extends ComponentOptions<string> {}

export const SpacerComponentEdit: FC<Props> = ({ value }) => {
    const height = useSpacerHeight(value);

    return (
        <div
            className="relative flex justify-center items-center w-full box-border z-0"
            style={{
                height,
            }}
        >
            <div className="absolute top-0 bottom-0 mx-auto border-y border-y-neutral-500 w-[21px] -z-10">
                <div className="h-full w-[10px] border-r border-neutral-500"></div>
            </div>
            <div className="text-xs bg-white text-black">
                {height}
            </div>
        </div>
    );
};
